import React, { useState, useEffect } from 'react';
import './UserModal.css'
import { postData } from '../../../services/apiServices';
import toastService from '../../../services/toastService';
function UserModal({ show, handleClose, isEdit, userData, refreshUsers }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [userId, setUserId] = useState('')
  const [userType, setUserType] = useState('User');
  const [userCanCreateOffer, setUserCanCreateOffer] = useState('No');


  useEffect(() => {
    if (isEdit && userData) {
      setFirstName(userData.firstname);
      setLastName(userData.lastname);
      setEmail(userData.email);
      setPhone(userData.phone);
      setUserType(userData.usertype);
      setUserId(userData?.id)
    } else {
      // Reset fields for adding a new user
      setFirstName('');
      setLastName('');
      setEmail('');
      setPhone('');
      setUserType('User');
      setUserId('')

    }
  }, [isEdit, userData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // API call to add or edit user
    const user = { firstName, lastName, email, phone, userType };
    if (isEdit) {
      editUser()
      console.log(user, "User Data which is clicked44")
    } else {
      addNewUser()
    }
    handleClose();
  };


  const editUser = async () => {
    const data = {
      "verification_token": "123456",
      "email": email,
      "firstname": firstName,
      "lastname": lastName,
      "usertype": userType,
      "status": "active",
      "userid": userId,
      "can_create_offer" : userCanCreateOffer

    }
    try {
      const result = await postData('/edit_user', data)
      console.log(result, "all users list")
      if (result.message == "success") {
        toastService.showSuccess("User Edit Successfully")
        refreshUsers();
      }
    } catch (error) {
      console.log(error, "get user error")
    }

  }

  const addNewUser = async () => {
    try {
      const data = {
        firstname: firstName,
        lastname: lastName,
        email: email,
        password: password,
        phone: phone,
        usertype: userType,
        status: "active",
        verification_token: '123456'
      };
      const result = await postData('/user', data)
      console.log(result, "result of the api sign up")
      if (result?.message === "fail") {
        toastService.showError(result?.description)
      } else if (result?.message === "success") {
        toastService.showSuccess("Registered Successfully")
        refreshUsers();
      } else {
        toastService.showError("Registration Fail")
      }

    } catch (error) {
      console.log(error, "error in signin api")
      toastService.showError("Someting went wrong")

    }
  }


  return (
    <div className={`modal ${show ? 'show' : ''}`}>
      <div className="modal-content">
        <h2>{isEdit ? 'Edit User' : 'Add User'}</h2>
        <form onSubmit={handleSubmit}>
          <label>First Name:</label>
          <input
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
          <label>Last Name:</label>
          <input
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label>Phone:</label>
          <input
            type="text"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          {isEdit ? null :
            <>
              <label>Password:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </>
          }
          <label>User Type:</label>
          <select
            value={userType}
            onChange={(e) => setUserType(e.target.value)}
          >
            <option value="User">User</option>
            <option value="Supervisor">Supervisor</option>
            <option value="SuperAdmin">SuperAdmin</option>
          </select>

          {isEdit ? (
            <>
              <label>Can User Create Offer:</label>
              <select
                value={userCanCreateOffer}
                onChange={(e) => setUserCanCreateOffer(e.target.value)}
              >
                <option value="User">Yes</option>
                <option value="Supervisor">No</option>
              </select>
            </>
          ) : null}

          <div className="modal-actions">
            <button type="submit" className="btn save-btn">{isEdit ? 'Save Changes' : 'Add User'}</button>
            <button type="button" className="btn cancel-btn" onClick={handleClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserModal;
